import { cn } from '@/legacy-src/lib/utils'

import {
  HeaderNavigationContent,
  type HeaderNavigationContentProps,
} from '@/src/domains/header/components/Header/HeaderNavigationContent'

export const HeaderDesktopNavigationContent = (props: HeaderNavigationContentProps) => (
  <HeaderNavigationContent
    {...props}
    className={cn(
      'data-[motion^=from-]:animate-in data-[motion^=to-]:animate-out data-[motion^=from-]:fade-in data-[motion^=to-]:fade-out data-[motion=from-end]:slide-in-from-right-52 data-[motion=from-start]:slide-in-from-left-52 data-[motion=to-end]:slide-out-to-right-52 data-[motion=to-start]:slide-out-to-left-52',
      props.className,
    )}
  />
)
